
<template>
  <div>
    <div style="margin-top: 10px;margin-left: 10px">
      <a-radio-group  v-model="viewType"  size="small">
        <a-radio-button value="1">
          图表视图
        </a-radio-button>
        <a-radio-button value="2">
          表格视图
        </a-radio-button>
      </a-radio-group>
    </div>
    <a-card :bordered="false">
      <template v-if="viewType==='1'">
        <a-row :gutter="20" v-if="periodItemList.length>0">
          <a-col :span="4" class="left-link">
            <div class="link-btn" v-for="(item,index) in dataSource" :key="index">
              <div class="btn" :class="index+'' == activeKey?'select':'no-select'" @click="activeKey=index+''">
                <div style="text-align: left">
                  {{item.list[0].formname }}
                </div>
                <div style="text-align: left">
                  {{ item.list[0].formitemname}}
                </div>

              </div>
            </div>
          </a-col>
          <a-col :span="20">
            <a-tabs class="tabs" v-model="activeKey"  >
              <a-tab-pane  :key="index+''"  v-for="(item,index) in dataSource">
                <charts  :baseDataList="item.list" :periodItemList="periodItemList">
                </charts>
              </a-tab-pane>
            </a-tabs>       
          </a-col>
        </a-row>
      </template>
      <verdict-table v-else></verdict-table>
    </a-card>
  </div>
</template>

<script>
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'
  import Vue from 'vue'
  import VerdictTable from './VerdictTable'
  import Charts from './verdict/Charts'
  export default {
    name: "Verdict",
    components: {
      Charts,
      VerdictTable
    },
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {},
        dataSource:{},
        periodItemList:[],
        formInfoList:[],
        activeKey:'0',
        viewType:'1',

      }
    },
    computed: {
    },
    mounted(){
      this.queryParam.projectId = this.projectId
      this.loadDataPeriod()
      this.loadData()
    },
    watch:{

    },
    methods: {
      tabName(item){
        if(this.dataSource.length===0){
          return ''
        }
        return item.list[0].formname +'-'+ item.list[0].formitemname
      },
      loadDataPeriod(){
        getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0'}).then(res=>{
          if(res.success) {
            this.periodItemList = res.result
          }
        })
      },
      loadData(){
        // this.queryParam.useCache = false
        getAction('/project/statistic/verdict/info2',this.queryParam).then(res=>{
          if(res.success){
            this.dataSource = res.result
          }
        })
      },
      loadDataCallback(){

      }
    }
  }
</script>
<style scoped lang="less">
  .title{

    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
  .left-link{
    max-width: 100%;
    overflow-x: auto;
    height: calc(100vh - 210px);
    padding-right: 10px;
    .link-btn{
      margin-bottom: 15px;
      .select{
        color: #5470C6;
      }
      .no-select{
        color: rgba(0,0,0,0.7);
      }
      .btn{
        cursor: pointer;
        border-bottom: 1px solid @primary-color;
        border-bottom: 1px solid @primary-color;
      }
      .btn:hover{
        color: @primary-color;
      }
    }
  }
</style>
